export const apiEndPoint='https://47qrryhcj8.execute-api.us-east-1.amazonaws.com/prod/';
export const cognitoIdentityPoolId='us-east-1:bb37889f-4678-42b7-b4e4-74a966f2ea1f';
export const userPoolId='us-east-1_hTamtsFL5';
export const userPoolClientId='13rtpb3di2s2j5sja934iv9mic';
export const cognitoDomain='worldcup-avatar-auth.auth.us-east-1.amazoncognito.com';
export const oauthRedirectUri='https://worldcup.demos.dxconnel.people.aws.dev/';
export const oauthIdentityProvider='midway';
